import {groq} from 'next-sanity';

import {CONTENT_BLOCKS_FRAGMENT} from '@/modules/foundation/sanity/content-blocks/query';
import {PAGE_HEADINGS_FRAGMENT} from '@/modules/foundation/sanity/page-head/query';
import {DOCUMENT_TYPE_PAGE} from '@/modules/page/sanity/page/constants';

export const PAGE_FRAGMENT = `//groq
	...,
	pageHeadings[]{
		${PAGE_HEADINGS_FRAGMENT}
	},
	content[]{
		${CONTENT_BLOCKS_FRAGMENT}
	}
`;

export const pageBySlugQuery = groq`
*[_type == "${DOCUMENT_TYPE_PAGE}" && slug.current == $slug][0]{
	${PAGE_FRAGMENT}
}
`;
